// The overall scroll position of the Gym details page; saved separately from the internal scroll state of Calendar
const GYM_DETAIL_SCROLL_KEY_PREFIX = "gymDetailPageScroll_";

const getGymDetailScrollKey = (businessId: string) => `${GYM_DETAIL_SCROLL_KEY_PREFIX}${businessId}`;

export const saveGymDetailScrollPosition = (businessId: string) => {
  const container = document.getElementById("layout-container");
  if (!container || !businessId) return;
  sessionStorage.setItem(getGymDetailScrollKey(businessId), String(container.scrollTop));
};

export const getGymDetailScrollPosition = (businessId: string) => {
  const value = sessionStorage.getItem(getGymDetailScrollKey(businessId));
  if (value === null) return null;
  const scrollTop = Number(value);
  return Number.isFinite(scrollTop) ? scrollTop : null;
};

export const clearGymDetailScrollPosition = (businessId: string) => {
  if (!businessId) return;
  sessionStorage.removeItem(getGymDetailScrollKey(businessId));
};

export const clearAllGymDetailScrollPositions = () => {
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith(GYM_DETAIL_SCROLL_KEY_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  });
};
